/**
* @name: breadcrumb-container
* @author: weiyong
* @date: 2023-05-11 21:07
* @description：breadcrumb-container
* @update: 2023-05-11 21:07
*/
<template>
  <div class="breadcrumb-container">
    <i style="font-size: 24px;" :class="crumbObj.source||'remix-icon ri-dashboard-line2'"/>
    <div class="el-txt el-txt--h5" style="margin-left: 0px;">{{crumbObj.name||'首页'}}</div>
    <div class="el-divider el-divider--vertical divider" role="separator"
         style="--el-border-style: solid;"></div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "remix-icon breadcrumb-container",
});
</script>

<script lang="ts" setup>
import eventBus from "@/events/eventBus";
import {useBreadCrumbHook} from "@/layouts/layoutFrame/scaLayout/hooks/useBreadCrumbHook";

const {crumbObj}=useBreadCrumbHook();

</script>

<style type="text/css" lang="less">
.breadcrumb-container{
  .remix-icon{
    color:var(--primary-color,#0a6eff);
  }
}
</style>
